<template>
  <label :for="id">
    <p class="my-1">{{ label }}</p>
    <div class="relative block mx-auto">
      <span class="flag">
        <htech-img
          name="flag"
          layout="fixed"
          object-fit="cover"
          width="32px"
          height="32px"
          :src="imgSrc"
          :alt="alt"
          style="border-radius: 50%;"
          data-testid="input-flag"
        />
      </span>

      <span class="lada">
        {{ lada }}
      </span>

      <input
        :id="id"
        v-model="localValue"
        class="input-number"
        :class="{'withLada': lada}"
        :placeholder="placeholder"
        :pattern="pattern"
        :type="type"
        :maxlength="maxLength"
        data-testid="input-number"
        :aria-errormessage="ariaErrormessage"
        :aria-invalid="ariaInvalid"
        @keyup.enter="onEnter"
        @focus="onFocus"
        @blur="onBlur"
        @input="onInput"
      />
    </div>
  </label>
</template>

<script>
import { flags, COUNTRY as i18n } from '@/utils/constants';

export default {
  name: 'InputPhone',
  props: {
    type: { type: String, default: 'text' },
    name: { type: String, default: 'tel' },
    maxLength: {
      type: Number,
      default: 10
    },
    country: {
      type: String,
      required: true
    },
    placeholder: { type: String, default: '' },
    pattern: { type: String, default: '' },
    lada: { type: String, required: true },
    label: {
      type: String,
      default: 'Número de teléfono'
    },
    onlyNumbers: {
      type: Boolean,
      default: true
    },
    id: {
      type: String,
      default: 'phone__input'
    },
    error: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    ariaErrormessage: {
      type: String,
      default: 'error1'
    },
    ariaInvalid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focused: false,
      imgSrc: `img/flags/${flags[this.country]}`,
      localValue: this.value
    };
  },
  computed: {
    alt() {
      return i18n[this.country].name;
    }
  },
  watch: {
    type() {
      this.$emit('input', this.filter(this.localValue));
    },
    value() {
      if (this.localValue !== this.value) {
        this.localValue = this.filter(this.value);
        this.$emit('input', this.localValue);
      }
    }
  },
  methods: {
    onEnter() {
      this.$emit('enter', this.localValue);
    },
    filter(value) {
      const regex = this.onlyNumbers ? /\D/g : /[^0-9a-zA-Z]/g;
      return (value.replace(regex, '')).substring(0, this.maxLength).toUpperCase();
    },
    onFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    onBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
    },
    onInput() {
      this.localValue = this.filter(this.localValue);
      this.$emit('input', this.localValue);
    }
  }
};
</script>

<style scoped>
.input-number {
  @apply block w-full py-2 px-2 border rounded-3xl shadow-sm;
  @apply border-grey pl-[4.5rem] text-xl;
  @apply focus:ring-teal-blue focus:ring-1 focus:outline-none focus:border-teal-blue;
}

.withLada {
  @apply pl-[7.5rem];
}

.flag {
  @apply absolute inset-y-0 left-0 flex items-center px-[.625rem] my-2;
  @apply border-r-2 border-grey font-bold;
}
.lada {
  @apply absolute inset-y-0 left-12 flex items-center px-4 my-2 font-bold text-xl;
}
</style>
